
// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import { toast } from "sonner";
import logger from "@/utils/logger";
import { CustomDatabase } from "./types/database";
import { getSupabaseConfig, cleanupOldTokens } from "./config/environment";
import { setupAuthListeners } from "./config/authListeners";

// Get configuration
const config = getSupabaseConfig();

// Clean up old tokens
cleanupOldTokens();

// Create the Supabase client
export const supabase = createClient<CustomDatabase>(config.url, config.key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: config.storageKey,
  },
  global: {
    // Add default error handler
    fetch: (...args: [RequestInfo | URL, RequestInit | undefined]) => {
      return fetch(args[0], args[1]).catch((error) => {
        logger.error("Supabase fetch error:", error);
        toast.error(
          "Connection error. Please check your internet connection and try again."
        );
        throw error;
      });
    },
  },
});

// Set up authentication listeners
setupAuthListeners(supabase);

export type { CustomDatabase };
